'use client';

import { useState } from 'react';
import { MaskedPhoneInput } from '@/components/ui/MaskedPhoneInput';

export function ContactForm() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    // TODO: send email
    setSubmitted(true);
  }

  if (submitted) {
    return (
      <div className="text-center py-8">
        <p className="text-lg font-medium text-primary">Thank you for your message!</p>
        <p className="text-text-secondary mt-2">We will get back to you as soon as possible.</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <label htmlFor="name" className="block text-sm font-medium text-text-primary mb-1">
          Name <span className="text-error">*</span>
        </label>
        <input
          type="text"
          id="name"
          name="name"
          required
          value={form.name}
          onChange={handleChange}
          className="w-full rounded-lg border border-border-base bg-surface px-4 py-3 text-text-primary placeholder:text-text-tertiary focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors"
          placeholder="Your name"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-text-primary mb-1">
            Email <span className="text-error">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            required
            value={form.email}
            onChange={handleChange}
            className="w-full rounded-lg border border-border-base bg-surface px-4 py-3 text-text-primary placeholder:text-text-tertiary focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors"
            placeholder="your@email.com"
          />
        </div>

        <div>
          <label htmlFor="phone" className="block text-sm font-medium text-text-primary mb-1">
            Phone
          </label>
          {/* The same masked input the rest of the site uses: one way to type a
              phone, one shape on screen, and `form.phone` holds the canonical
              digits — so the day this form actually sends somewhere, it sends a
              number in the same form as everything else. */}
          <MaskedPhoneInput
            name="phone"
            value={form.phone}
            onChange={handleChange}
            className="w-full rounded-lg border border-border-base bg-surface px-4 py-3 text-text-primary placeholder:text-text-tertiary focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors"
          />
        </div>
      </div>

      <div>
        <label htmlFor="message" className="block text-sm font-medium text-text-primary mb-1">
          Message <span className="text-error">*</span>
        </label>
        <textarea
          id="message"
          name="message"
          required
          rows={5}
          value={form.message}
          onChange={handleChange}
          className="w-full rounded-lg border border-border-base bg-surface px-4 py-3 text-text-primary placeholder:text-text-tertiary focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors resize-y"
          placeholder="Your message..."
        />
      </div>

      <button
        type="submit"
        className="w-full rounded-lg bg-primary text-onprimary font-medium py-3 px-6 hover:bg-primary-hover active:bg-primary-pressed transition-colors cursor-pointer"
      >
        Send Message
      </button>
    </form>
  );
}
